module.exports = {
  title: 'Privacy Policy',
  author: 'Enzo Manuel Mangano',
  date: '2024-12-07',
  slug: 'privacy',
  tags: ['docs', 'privacy-policy'],
};
